import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

@Component({
	selector: 'vtr-ui-hyperlink-button',
	templateUrl: './ui-hyperlink-button.component.html',
	styleUrls: ['./ui-hyperlink-button.component.scss'],
})
export class UiHyperlinkButtonComponent implements OnInit {
	@Input() hyperlinkStyle: string;
	@Input() label: string;
	@Input() title: string;
	@Input() linkId: string;
	@Input() linkRole: string;
	@Input() tabIndex: number;
	@Input() upperCaseLabel: boolean;
	@Input() capitalizeLabel: boolean;
	@Input() isDisabled = false;

	@Input() ariaLabel: string;
	@Input() tooltipText: string;
	@Input() disableTooltip = false;

	@Input() faIcon: IconProp;
	@Input() faIconStyle: string;
	@Input() imgIconSrc: string;

	@Output() hyperlinkClick = new EventEmitter();

	constructor() {}

	ngOnInit(): void {
		this.linkRole = this.linkRole ?? 'link';
		this.ariaLabel = this.ariaLabel ?? this.label;
		this.tooltipText = this.tooltipText ?? this.label;
		this.faIconStyle = this.faIconStyle ?? this.hyperlinkStyle;
	}

	onClick() {
		if (!this.isDisabled) {
			this.hyperlinkClick.emit();
		}
	}
}
